import React from "react";

const Footer = () => {
    return (
        <footer>
            <strong>Created with sleepless nights by Daffa Alif</strong>
        </footer>
    )
}

export default Footer
